export default "__VITE_ASSET__O4m$mGle__"